export * from './customer-account.links.component';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/customer-account/customer-account-links/index.ts